<template>
  <div>
    <modal-log :dataLog="dataLog"></modal-log>
    <modal-eliminar
      :action="action"
      :dataLog="dataLog"
      @oculto="ocultarLog"
    ></modal-eliminar>
    <b-card no-body class="p-1">
      <div v-if="!USER().is_auditor" class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
          <h2 class="mb-1">
            Tú no estas autorizado! 🔐
          </h2>
          <p class="mb-2">
            No tienes los permisos para ver esta página. !!
          </p>
          <b-img
            fluid
            :src="require('@/assets/images/pages/not-authorized.svg')"
            alt="Pagina no autorizada"
            style="width:50%"
          />
        </div>
      </div>
      <b-overlay v-else :show="showLoading" rounded="sm">
        <b-row>
          <b-col>
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1 mb-1"
              placeholder="Buscar por (usuario / sección / tipo / descripción)"
            />
          </b-col>
          <b-col md="4">
            <flat-pickr
              placeholder="Filtrar x fecha"
              class="form-control"
              v-model="rangeDate"
              :config="{ mode: 'range' }"
            />
          </b-col>
        </b-row>
        <div v-if="listLogsFilter.length" class="logs-table-wrap">
          <div class="logs-grid logs-grid-header" role="row">
            <div class="logs-grid-cell logs-grid-id">#</div>
            <div class="logs-grid-cell logs-grid-date">fecha__</div>
            <div class="logs-grid-cell logs-grid-user">usuario</div>
            <div class="logs-grid-cell logs-grid-section">sección</div>
            <div class="logs-grid-cell logs-grid-description">descripción</div>
            <div class="logs-grid-cell logs-grid-type">tipo</div>
            <div class="logs-grid-cell logs-grid-actions"></div>
          </div>
          <virtual-list
            class="logs-virtual-list"
            :data-key="'id_movimiento'"
            :data-sources="listLogsFilter"
            :data-component="logVirtualRow"
            :keeps="30"
            :estimate-size="58"
            :extra-props="{
              isSuperUser: USER().rol === ROLES.SUPER,
              onShowDetails: showModalLog,
              onDelete: item => showLogEliminar(item, 'eliminar'),
            }"
          />
        </div>
        <div v-else class="text-center py-3">No se encontraron datos</div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BOverlay,
  BFormInput,
  BRow,
  BCol,
  BImg,
  //   BIconLayers,
} from 'bootstrap-vue'
import {
  ref,
  onMounted,
  computed,
  watch,
  //   xxx,
  //   xxx,
  //   xxxx,
} from '@vue/composition-api'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import VirtualList from 'vue-virtual-scroll-list'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
  //   ESTADO_JUGADOR,
} from '../../utils/variables'
import modalLog from './LogDetalle.vue'
import modalEliminar from './ModalConfirmacion.vue'
import LogVirtualRow from './LogVirtualRow.vue'

export default {
  components: {
    BCard,
    BOverlay,
    'virtual-list': VirtualList,
    modalLog,
    modalEliminar,
    BFormInput,
    BRow,
    BCol,
    flatPickr,
    BImg,
  },
  setup() {
    const showLoading = ref(false)
    const action = ref('ocultar')
    const searchQuery = ref('')
    const rangeDate = ref(null)
    const logVirtualRow = LogVirtualRow
    const listLogs = ref([])
    const dataLog = ref(null)
    const { getApi } = apiCall()

    async function getLogs(idTorneo) {
      listLogs.value = []
      showLoading.value = true
      const path = `ApiMovimientos/getMovimientos/${idTorneo}`
      const data = await getApi(URL, path)
      listLogs.value = data.data
      showLoading.value = false
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    watch(cambioTorneo, () => {
      getLogs(store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
    })
    onMounted(() => {
      getLogs(store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
      // console.log(refP.value)
    })

    function showModalLog(item) {
      dataLog.value = item
      store.commit('someVariables/UPDATE_SHOW_MODAL_LOG', true)
    }
    function showLogEliminar(item, method) {
      action.value = method
      dataLog.value = item
      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_LOG', true)
    }
    function separaFecha() {
      // console.log(rangeDate.value)
      let auxiliar = null
      if (rangeDate.value != null) {
        const arrayFechas = rangeDate.value.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[0].trim(),
          }
        }
      }
      if (rangeDate.value === '') {
        // auxiliar = {
        //   valido: false,
        //   inicio: null,
        //   fin: null,
        // }
        auxiliar = null
      }
      return auxiliar
    }

    const listLogsFilter = computed(() => {
      const fecha = separaFecha()
      let listReturn = listLogs.value
      if (fecha != null && searchQuery.value === '') {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listLogs.value.filter(
            log =>
              // eslint-disable-next-line
              log.fecha >= `${fecha.inicio} 00:00:00` &&
              // eslint-disable-next-line
              log.fecha <= `${fecha.fin} 23:59:59`,
            // eslint-disable-next-line
          )
        }
      } else if (fecha === null && searchQuery.value !== '') {
        // eslint-disable-next-line
        listReturn = listLogs.value.filter(
          player =>
            // eslint-disable-next-line
            player.nombre_completo
              .toLowerCase()
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.tipo
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.accion
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.tipo_dato
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase()),
          // eslint-disable-next-line
        )
      } else if (fecha !== null && searchQuery.value !== '') {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listLogs.value.filter(
            player =>
              // eslint-disable-next-line
              (player.nombre_completo
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.tipo
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.accion
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.tipo_dato
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`),
            // eslint-disable-next-line)
          )
        }
      }

      // listReturn = listLogs.value.filter(
      //   player =>
      //     // eslint-disable-next-line
      //     player.nombre_completo
      //       .toLowerCase()
      //       .includes(searchQuery.value.toLowerCase()) ||
      //     // eslint-disable-next-line
      //     player.rol.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      //     // eslint-disable-next-line
      //     player.tipo.toLowerCase().includes(searchQuery.value.toLowerCase())
      //   // eslint-disable-next-line
      // )
      return listReturn
      // eslint-disable-next-line
    })
    async function ocultarLog() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'SANCION ELIMINADA exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-bottom',
          // eslint-disable-next-line
        },
      )
      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_LOG', false)
      getLogs(store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
    }

    return {
      showLoading,
      listLogs,
      showModalLog,
      modalLog,
      dataLog,
      ocultarLog,
      showLogEliminar,
      action,
      USER,
      ROLES,
      listLogsFilter,
      searchQuery,
      rangeDate,
      logVirtualRow,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.logs-table-wrap {
  max-height: 70vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.logs-grid {
  min-width: 960px;
  grid-template-columns: 70px 160px minmax(180px, 1.2fr) minmax(120px, 1fr) minmax(
      240px,
      2fr
    ) 100px 70px;
}

.logs-grid-header,
.logs-grid-row {
  display: grid;
  grid-template-columns: 70px 160px minmax(180px, 1.2fr) minmax(120px, 1fr) minmax(
      240px,
      2fr
    ) 100px 70px;
}

.logs-grid-header {
  min-height: 42px;
  align-items: center;
  background-color: #f8f8f8;
  border-bottom: 1px solid #ebe9f1;
  font-size: 0.857rem;
  font-weight: 600;
  text-transform: uppercase;
}

.logs-virtual-list {
  min-width: 960px;
  height: calc(70vh - 42px);
  overflow-y: auto;
}

.logs-grid-row {
  min-width: 960px;
  width: 100%;
  min-height: 58px;
  align-items: center;
  border-bottom: 1px solid #ebe9f1;
}

.logs-grid-cell {
  min-width: 0;
  padding: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logs-grid-actions {
  text-align: center;
}
</style>
